import { Link } from 'react-router-dom';
import { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300 transition-all duration-200"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.coverImage}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={video.title}
        />
        <div className="absolute top-3 left-3">
          <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-background-950/70 text-background-50 backdrop-blur-sm">
            {video.quality}
          </span>
        </div>
        <div className="absolute bottom-3 right-3">
          <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-background-950/70 text-background-50 backdrop-blur-sm">
            {video.duration}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {video.rating}
          </span>
          <span>{video.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views > 10000 ? `${(video.views / 10000).toFixed(0)}万` : video.views}
          </span>
        </div>
      </div>
    </Link>
  );
}